<template>
    <div class="email-container">
      <!-- 顶部工具栏 -->
      <div class="email-toolbar">
        <div class="left-actions">
          <button class="btn-refresh" @click="refreshEmails">
            <i class="el-icon-refresh"></i> 刷新
          </button>
          <el-select v-model="currentFolder" placeholder="选择文件夹" class="folder-select">
            <el-option
              v-for="folder in folders"
              :key="folder.value"
              :label="folder.label"
              :value="folder.value">
            </el-option>
          </el-select>
        </div>
        <!-- <div class="right-actions">
          <el-input
            v-model="searchQuery"
            placeholder="搜索邮件..."
            prefix-icon="el-icon-search"
            class="search-input">
          </el-input>
        </div> -->
      </div>
  
      <!-- 邮件列表 -->
      <div class="email-list">
        <div 
          v-for="email in filteredEmails"
          :key="email.id"
          :class="['email-item', { 'unread': !email.is_read, 'selected': selectedEmailId === email.id }]"
          @click="selectEmail(email.email_log_id)">
          
          <div class="email-checkbox">
            <el-checkbox v-model="email.checked"></el-checkbox>
          </div>
          
          <div class="email-star" @click.stop="toggleStar(email.id)">
            <i :class="['el-icon-star-off', { 'starred': email.starred }]"></i>
          </div>
          
          <div class="email-sender">
            <el-avatar :src="email.avatar" size="small"></el-avatar>
            <span class="sender-name">{{ email.sender_name }}</span>
          </div>
          
          <div class="email-content">
            <div class="email-subject">
              <span>{{ email.subject }}</span>
              <span class="email-preview"> - {{ email.preview }}</span>
            </div>
          </div>
          
          <div class="email-time">
            {{ email.create_time }}
            <i 
              v-if="email.attachments > 0"
              class="el-icon-paperclip attachment-icon">
            </i>
          </div>
        </div>
      </div>
  
      <!-- 分页控件 -->
      <div class="email-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalEmails">
        </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  import MessageApi from '../../../api/message';
  export default {
    name: 'EmailList',
    data() {
      return {
        emails: [],
        selectedEmailId: null,
        currentFolder: 'inbox',
        folders: [
          { value: 'inbox', label: '收件箱' },
        //   { value: 'starred', label: '星标邮件' },
        //   { value: 'sent', label: '已发送' },
        //   { value: 'drafts', label: '草稿箱' },
        //   { value: 'trash', label: '垃圾箱' }
        ],
        searchQuery: '',
        currentPage: 1,
        pageSize: 20,
        totalEmails: 0,
        tagTypes: {
          '重要': 'danger',
          '工作': 'warning',
          '个人': 'success',
          '通知': 'info'
        }
      }
    },
    computed: {
      filteredEmails() {
        let filtered = this.emails;
        
        // 按文件夹过滤
        if (this.currentFolder === 'starred') {
          filtered = filtered.filter(email => email.starred);
        } else if (this.currentFolder !== 'inbox') {
          filtered = filtered.filter(email => email.folder === this.currentFolder);
        }
        
        // 搜索过滤
        if (this.searchQuery) {
          const query = this.searchQuery.toLowerCase();
          filtered = filtered.filter(email => 
            email.subject.toLowerCase().includes(query) || 
            email.sender_name.toLowerCase().includes(query) ||
            email.content.toLowerCase().includes(query)
          );
        }
        
        return filtered;
      }
    },
    created() {
      this.fetchEmails();
    },
    methods: {
      async fetchEmails() {
        try {
          const response = await MessageApi.emaillist({
            params: {
              page: this.currentPage,
              size: this.pageSize
            }
          });
          
          this.emails = response.data.data.map(email => ({
            ...email,
            checked: false,
            avatar: this.getAvatar(email.sender_id)
          }));
          this.totalEmails = response.data.total;
        } catch (error) {
          console.error('获取邮件列表失败:', error);
          this.$message.error('获取邮件列表失败');
        }
      },
      
      getAvatar(senderId) {
        return senderId === 0 
        //   ? require('@/assets/images/system-notification.png')
        //   : `/api/avatar/${senderId}`;
      },
      
      formatTime(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        
        if (date.toDateString() === now.toDateString()) {
          return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        } else if (date.getFullYear() === now.getFullYear()) {
          return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
        } else {
          return date.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' });
        }
      },
      
      selectEmail(emailId) {
        console.log('emailId',emailId)
        this.selectedEmailId = emailId;
        this.markAsRead(emailId);
        this.$emit('email-selected', emailId);
        let self = this;
        this.$router.push({
          path: '/service/index/emaildetail',
          query: {
            emailId: emailId 
            }
          });
      },
      
      async markAsRead(emailId) {
        try {
          await this.$http.post(`/api/emails/${emailId}/read`);
          const email = this.emails.find(e => e.id === emailId);
          if (email) email.is_read = true;
        } catch (error) {
          console.error('标记已读失败:', error);
        }
      },
      
      async toggleStar(emailId) {
        try {
          const email = this.emails.find(e => e.id === emailId);
          if (email) {
            email.starred = !email.starred;
            await this.$http.post(`/api/emails/${emailId}/star`, { starred: email.starred });
          }
        } catch (error) {
          console.error('星标操作失败:', error);
        }
      },
      
      refreshEmails() {
        this.currentPage = 1;
        this.fetchEmails();
      },
      
      handleSizeChange(size) {
        this.pageSize = size;
        this.fetchEmails();
      },
      
      handleCurrentChange(page) {
        this.currentPage = page;
        this.fetchEmails();
      }
    }
  }
  </script>
  
  <style scoped>
  .email-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  .email-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    border-bottom: 1px solid #ebeef5;
  }
  
  .left-actions {
    display: flex;
    align-items: center;
  }
  
  .btn-refresh {
    padding: 8px 12px;
    margin-right: 15px;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    color: #606266;
  }
  
  .btn-refresh:hover {
    background: #ecf5ff;
    color: #409eff;
    border-color: #c6e2ff;
  }
  
  .folder-select {
    width: 150px;
  }
  
  .search-input {
    width: 250px;
  }
  
  .email-list {
    flex: 1;
    overflow-y: auto;
  }
  
  .email-item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .email-item:hover {
    background-color: #f5f7fa;
  }
  
  .email-item.unread {
    background-color: #f0f7ff;
    font-weight: 500;
  }
  
  .email-item.selected {
    background-color: #e8f4ff;
  }
  
  .email-checkbox {
    width: 40px;
    display: flex;
    justify-content: center;
  }
  
  .email-star {
    width: 40px;
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
  }
  
  .email-star .starred {
    color: #f7ba2a;
  }
  
  .email-sender {
    width: 200px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
  
  .sender-name {
    margin-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .email-content {
    flex: 1;
    min-width: 0;
    padding: 0 15px;
  }
  
  .email-subject {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
  }
  
  .email-preview {
    color: #909399;
  }
  
  .email-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  
  .email-time {
    width: 120px;
    text-align: right;
    color: #909399;
    font-size: 13px;
    white-space: nowrap;
  }
  
  .attachment-icon {
    margin-left: 5px;
    color: #909399;
  }
  
  .email-pagination {
    padding: 15px 20px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
  }
  </style>


// WEBPACK FOOTER //
// src/views/service/index/email.vue